<template>
  <div class="myDiagnosis">
    <el-card class="box-card" style="height: 100%">
      <div slot="header" class="clearfix">
        <span class="diagnosis-span">{{ name }}</span>
        <div class="tab">
          <el-tag class="tag" :effect="weekEffect" type="error" @click="initData('week')">最<p>近一</p>周</el-tag>
          <el-tag class="tag" :effect="monthEffect" type="success" @click="initData('month')">最<p>近一</p>月</el-tag>
          <!-- <el-tag
            class="tag"
            :effect="quarterEffect"
            type="info"
            @click="initData('quarter')"
            >最近一个季度</el-tag
          > -->
          <el-tag class="tag" :effect="yearEffect" type="warning" @click="initData('year')">最<p>近一</p>年</el-tag>
        </div>
      </div>
      <div class="text item">
        <div id="Myecharts" style="width: 100%; height: 380px"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import echarts from "echarts";
// import { getIndexChart } from "@/api";
export default {
  name: "",
  components: {},
  props: {
    name: String,
  },
  data() {
    return {
      eTimeVal: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      eDataVal: [820, 932, 901, 934, 1290, 1330, 1320],
      monthEffect: "plain",
      quarterEffect: "plain",
      yearEffect: "plain",
      weekEffect: "plain",
      myEchart: "",
    };
  },
  created() { },
  mounted() {
    this.myEchart = echarts.init(document.getElementById("Myecharts"));
    // this.initData("week");
  },
  methods: {
    resize() {
      this.myEchart.resize();
    },
    reastData() {
      this.monthEffect = "plain";
      this.quarterEffect = "plain";
      this.yearEffect = "plain";
      this.weekEffect = "plain";
    },
    async initData(type) {
      try {
        await this.reastData();
        var cur = type + "Effect";
        this[cur] = "dark";

        let data = {
          week: type === "week" ? 1 : 0,
          year: type === "year" ? 1 : 0,
          // quarter: type === "quarter" ? 1 : 0,
          month: type === "month" ? 1 : 0,
          type: "1", //1、医生个人统计 2、平台统计
        };
        let res = await getIndexChart(data);
        if (res.success) {
          let data = res.result;
          data.name = this.setDateType(type);
          this.initEcharts(data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    setDateType(type) {
      switch (type) {
        // case "week":
        //   return "周";
        //   break;
        // case "month":
        //   return "月";
        //   break;
        // case "quarter":
        //   return "季";
        //   break;
        // case "year":
        //   return "年";
        //   break;
      }
    },
    initEcharts(my) {
      let option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: my.eTimeVal,
          name: my.name,
        },
        yAxis: {
          type: "value",
          name: "个",
          minInterval: 1, //设置成1保证坐标轴分割刻度显示成整数。
        },
        series: [
          {
            data: my.eDataVal,
            type: "line",
          },
        ],
      };
      this.myEchart.setOption(option);
    },
  },
  filter: {},
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.diagnosis-span {
  display: block;
}

.tab {
  text-align: right;
  display: block;
  position: relative;
  bottom: 25px;
  height: 0px !important;
  .tag {
    font-size: 14px;
    cursor: pointer;
    display: inline-block;
    background: #fff8f3 !important;
    color: #fc701a !important;
    border: #fff8f3 1px solid;
  }
  .tag p {
    display: inline;
    padding-bottom: 4px;
  }
}
.myDiagnosis {
  height: 100%;
  .text {
    height: 100%;
  }
}

.myDiagnosis .el-card {
  box-shadow: none !important;
}
</style>
